import React, { useEffect, useMemo, useRef, useState } from "react";
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import i18n from "utils/i18n";
import ProfileTab from './_tabs/profile'
import ErTab from './_tabs/er';
import FooterBar from 'components/organisms/FooterBar'
import EmployeeValues from '../_functions/Employee'
import HelperEmployee from 'utils/HelperEmployee'
import { useSelector } from 'react-redux'
import { dataConstants } from 'services/redux/data/constants'
import { FooterStyles } from 'styles/components/organisms/Footer'
import FormSubmitButton from 'components/atoms/FormSubmitButton'
import { FormStatus } from 'utils/constants/form-constants';
import TabbedContent from 'components/molecules/TabbedContent'
import HelperString from 'utils/helper-string'
import HelperSetting from 'utils/helper-setting'
import { settingsConstants } from 'utils/constants/settings-constants'
import _ from 'lodash'
import { useNavigation, useRoute } from '@react-navigation/native'
import { AppRoutes } from 'navigations/app-routes'
import { TESTID } from '_shared/config/testID'
import LoadingComponent from 'components/atoms/Loading'
import CommuteTab from 'scenes/home/more/profile/_tabs/commute'
import ProfileErrors from 'scenes/home/more/profile/_components/ProfileErrors'
import VStack from 'components/atoms/stack/VStack'

const HomeMoreProfileScene = () => {
	
	const route = useRoute();
	const navigation = useNavigation();
	
	const _employee = useSelector( state => {
		return state.data[dataConstants.EMPLOYEE];
	} )
	
	const layoutRef = useRef()
	
	const [ loading, setLoading ] = useState( true )
	const [ formStatus, setFormStatus ] = useState( FormStatus.NONE )
	const [ topTabbar, setTopTabbar ] = useState( null )
	const [ identifier, setIdentifier ] = useState( HelperString.random() )
	
	const fromProfileError = _.get( route.params, 'profileError', 'no' ) === 'yes';
	const errors = HelperEmployee.isValid( _employee );
	
	const [ isSaveDisabled, setIsSaveDisabled ] = useState( false );
	
	const tabErrorsRef = useRef( {} );
	const [ tabErrors, setTabErrors ] = useState( [] );
	
	const combinedErrors = useMemo( () => {
		return _.concat( errors, tabErrors );
	}, [ errors, tabErrors ] )
	
	useEffect( () => {
		if( fromProfileError && _.size( errors ) === 0 ) {
			if( navigation.canGoBack() ) {
				navigation.goBack();
			} else {
				navigation.reset({
					index: 0,
					routes: [
						//{
						//	name: AppRoutes.TABS,
						//	params: { screen: AppRoutes.TAB_TODAY },
						//},
						{
							name: AppRoutes.TAB_TODAY,
						}
					]
				})
			}
		}
	}, [ _employee ] )
	
	useEffect( () => {
		EmployeeValues.resetEmployee()
		setLoading( false )
	}, [] );
	
	const onSetTabErrors = () => {
		//setTabErrors( tabErrorsRef.current )
		const values = [];
		_.forEach( tabErrorsRef.current, ( value, key ) => {
			if( value === true ) {
				values.push( key )
			}
		})
		
		setTabErrors( values )
	}
	
	const submitForm = () => {
		EmployeeValues.submitEmployee( setFormStatus );
	}
	
	const submitButton = (
		<FormSubmitButton
			disabled={ combinedErrors.length > 0 || isSaveDisabled }
			onPress={ submitForm }
			formStatus={ formStatus }
			formStatusCallback={ setFormStatus }
			style={ [ FooterStyles.button, FooterStyles.buttonFill ] }
			testID={ TESTID.HOME.MORE.PROFILE.FORM_SUBMIT_BUTTON }>
			
			{ i18n.t( 'buttons.save' ) }
		</FormSubmitButton>
	);
	
	const tabBarItems = useMemo( () => {
		const componentProps = {
			setIsSaveDisabled,
			setError: ( key, value ) => {
				tabErrorsRef.current[ key ] = value;
				
				onSetTabErrors()
			},
			onUpdate: () => {
				setIdentifier( HelperString.random() )
			}
		}
		
		const result = [];
		result.push({
			key: 'profile',
			text: i18n.t( 'page.profile.profile.title'),
			scene: (props) => {
				return (
					<ProfileTab
						{ ...props }
						{ ...componentProps }
					/>
				)
			}
		})
		
		if( HelperSetting.isYes( settingsConstants.PROFILE_ENABLE_ERO_EDITING ) && HelperSetting.isYes( settingsConstants.ERO_ENABLE ) ) {
			result.push({
				key: 'er',
				text: i18n.t( 'page.profile.ero.title'),
				scene: (props) => {
					return (
						<ErTab
							{ ...props }
							{ ...componentProps }
						/>
					)
				}
			})
		}
		
		// Commute
		if( HelperSetting.isYes( settingsConstants.COMMUTE_ENABLE ) || HelperSetting.isYes( settingsConstants.BOOKING_ENABLE_PARKING_LICENSE_PLATE ) ) {
			result.push({
				key: 'commute',
				text: i18n.t( 'page.commute.commute.title'),
				scene: (props) => {
					return (
						<CommuteTab
							{ ...props }
							{ ...componentProps }
						/>
					)
				}
			})
		}
		
		return result;
	}, [] )
	
	const content = useMemo( () => {
		if( loading ) {
			return <LoadingComponent />;
		}
		
		return (
			<TabbedContent
				key={ HelperString.hash('profile-tabs' ) }
				topTabbar={ setTopTabbar }
				items={ tabBarItems }
			/>
		)
	}, [ loading, tabBarItems ])
	
	return (
		<ThemedSafeAreaComponentTop
			top={ false }>
			
			<ThemedLayout
				ref={ layoutRef }
				topNavigation={ true }
				topTabbar={ topTabbar }
				showBackButton={ combinedErrors.length === 0 }
				title={ i18n.t( 'page.profile.profile.title') }
				testID={ TESTID.HOME.MORE.SCREENS.PROFILE}>
				
				<VStack>
					<ProfileErrors errors={ combinedErrors } />
					
					{ content }
				</VStack>
			</ThemedLayout>
			
			{ !loading && (
				<FooterBar
					buttons={ submitButton }
					onHeightCallback={ layoutRef.current?.setFooterHeight }
				/>
			)}
		</ThemedSafeAreaComponentTop>
	);
}

export default HomeMoreProfileScene;
